import { Component } from '@angular/core';
import { botswanaConfig } from '../../../config/botswana-config'
import { coteivoryConfig } from '../../../config/Cote-ivory-config'
import { zimConfig } from '../../../config/zim-config'
import { defaultConfig } from '../../../config/default-config'
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ClientSideStorageService } from '../../services/client-side-storage.service';

export const CountryMap: { [key: string]: string } = {
  '72': 'Botswana',
  '716': 'Zimbabwe',
  '356': 'India',      // Add more as needed
  '384':'cotedivoire'
};

@Component({
  selector: 'app-tncpage',
  templateUrl: './tncpage.component.html',
  styleUrl: './tncpage.component.scss',
})
export class TncpageComponent {
  countryName: any;
  appName: string = "";
  smallappName: string = "";
  logoUrl: any;
  countryConfig: any;
  termsHtml: any;
  macAddress:any
  country:any;
  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private cStorage:ClientSideStorageService) {
    this.countryName = "country"
    this.setAppNameBasedOnCountry();
    this.macAddress = Math.random();
    this.cStorage.set('country', JSON.stringify([]));
    this.cStorage.set('macAddress', JSON.stringify(this.macAddress));
    this.country = JSON.parse(this.cStorage.get("country"));
    this.macAddress = JSON.parse(this.cStorage.get("macAddress"));
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      const country = params['country'];

      if (country) {
        this.countryName = country
        // Now remove the query param from the browser URL
        this.countryConfig = this.getConfigByCountry(this.countryName) ?? defaultConfig;
        this.logoUrl = this.countryConfig.headerpostlogo;
        this.loadTermsForCountryAPI(this.countryName);

        // Remove ?country=... from URL cleanly
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true
        });
      } else {
        this.countryName = 'country'
        

      }
    });

  }


  getConfigByCountry(country: any): any {
    switch (country) {
      case '72':
        return botswanaConfig;
      case '716':
        return zimConfig;
      case "384":
        return coteivoryConfig;
      default:
        return defaultConfig;
    }

  }

  
  loadTermsForCountry(country: any) {
    const countryName = CountryMap[country];
    const url = `assets/Termsfiles/${countryName.toLowerCase()}.html`;
    this.http.get(url, { responseType: 'text' }).subscribe(
      html => this.termsHtml = html,
      err => this.termsHtml = '<p>Terms not available for this region.</p>'
    );
  }
  

  
  loadTermsForCountryAPI(country: any) {
    const countryName = CountryMap[country];
      const httpOptions = {
      // 'userName': 'satheshjkv@gmail.com',
      'macAddress': this.macAddress,
      'country': this.country
    };
    let countryid = parseInt(country)
    let locale = this.countryConfig.language.toUpperCase()
    const url = environment.authUrl+`orchestration-service/admin/api/terms?country=${countryid}&type=MERCHANT&locale=${locale}&componentType=TERMS`;
    this.http.get(url, { headers: httpOptions, observe: 'response', withCredentials: true }).subscribe(
      html => this.termsHtml = (html as any).body?.data?.htmlContent,
      err => this.termsHtml = '<p>Terms not available for this region.</p>'
    );
  }


  setAppNameBasedOnCountry() {
    switch (this.countryName) {
      case 'India':
        this.appName = 'MyApp India';
        break;
      case 'USA':
        this.appName = 'MyApp USA';
        break;
      case 'Dubai':
        this.appName = 'MyApp Dubai';
        break;
      default:
        this.appName = 'SHIP2MYID-POST OFFICE DEALS APP';
        this.smallappName = 'Ship2MyID-Post Office Deals App';
    }
  }
}
